"use client";

import { useEffect, useState } from "react";

export interface ViewportInfo {
  width: number;
  height: number;
  breakpoint: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  mounted: boolean;
}

export function useViewportInfo(): ViewportInfo {
  const [info, setInfo] = useState<ViewportInfo>({
    width: 0,
    height: 0,
    breakpoint: "xs",
    mounted: false,
  });

  useEffect(() => {
    let rafId: number;

    function update() {
      const w = window.innerWidth;
      const h = window.innerHeight;
      let breakpoint: ViewportInfo["breakpoint"] = "xs";
      if (w >= 1536) breakpoint = "2xl";
      else if (w >= 1280) breakpoint = "xl";
      else if (w >= 1024) breakpoint = "lg";
      else if (w >= 768) breakpoint = "md";
      else if (w >= 640) breakpoint = "sm";

      setInfo({ width: w, height: h, breakpoint, mounted: true });
    }

    function onResize() {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    }

    update();
    window.addEventListener("resize", onResize, { passive: true });
    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return info;
}
